import NotificationsPage from "./NotificationPage";

export default NotificationsPage;
